import React from "react";
import {
  TextContainer,
  Paragraph,
} from "../styles/components/Global/Paragraph";
import {
  CreditsContainer,
  Column,
  Break,
} from "../styles/components/Global/Global";
import {
  SmallHeading,
  ImageCredits,
} from "../styles/components/Galleries/Global";

const Credits = () => {
  return (
    <>
      <CreditsContainer $noPadding>
        <Column $direction="row" $noWidth>
          <ImageCredits $align="flex-start" $heading>
            <SmallHeading>
              Jacket GUCCI, Pants S.R. STUDIO. LA. CA, Sunglasses CHRISHABANA
              Earrings DAVID YURMAN, Rings A$AP ROCKY’S OWN, Shoes ERL
            </SmallHeading>
          </ImageCredits>
        </Column>
      </CreditsContainer>
      <Break $size="small" $desktop />
      <CreditsContainer>
        <Column $direction="row">
          <Column>
            <Paragraph $size="small" $bold>
              HIGHSNOBIETY & A$AP ROCKY
            </Paragraph>
          </Column>
          <Column>
            <Paragraph $size="small" $bold>
              NOVEMBER 2023
            </Paragraph>
          </Column>
        </Column>
        <Break size="small" $mobile />
        <Column $align="flex-start" $direction="column" $margin>
          <TextContainer $direction="row">
            <Paragraph $size="small" $bold>
              BY&nbsp;
            </Paragraph>
            <Paragraph $style="deville" $size="medium">
              JORDAN COLEY
            </Paragraph>
          </TextContainer>
          <TextContainer>
            <Paragraph $size="small" $bold>
              PHOTOGRAPHED&nbsp;
            </Paragraph>
            <Paragraph $style="deville" $size="medium">
              RYAN MCGINLEY
            </Paragraph>
          </TextContainer>
          <TextContainer>
            <Paragraph $size="small" $bold>
              STYLED&nbsp;
            </Paragraph>
            <Paragraph $style="deville" $size="medium">
              SEBASTIAN JEAN
            </Paragraph>
          </TextContainer>
        </Column>
      </CreditsContainer>
    </>
  );
};

export default Credits;
